import { useLazyGetLoginStatusQuery } from '@/api';
import { FIVE_MINUTES_IN_MS } from '@/constants/request';
import { useEffect, useRef } from 'react';

export const useCheckLoginStatus = () => {
  const [triggerGetLoginStatus] = useLazyGetLoginStatusQuery();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    triggerGetLoginStatus({});

    intervalRef.current = setInterval(() => {
      triggerGetLoginStatus({});
    }, FIVE_MINUTES_IN_MS);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [triggerGetLoginStatus]);
};
